import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="location"
export default class extends Controller {
  static targets = ["latitudeField", "longitudeField"]

  // Add a flag to prevent endless loops
  isProcessing = false
  
  connect() {
    // If near_me is checked on page load, try to get location
    // But only if we don't already have coordinates
    const nearMeCheckbox = document.getElementById("near_me")
    if (nearMeCheckbox && nearMeCheckbox.checked && 
        (!this.latitudeFieldTarget.value || !this.longitudeFieldTarget.value)) {
      this.getLocation()
    }
  }

  toggleNearMe(event) {
    if (this.isProcessing) return
    
    this.isProcessing = true
    
    if (event.target.checked) {
      this.getLocation()
    } else {
      // Clear the coordinates when unchecked
      this.latitudeFieldTarget.value = ""
      this.longitudeFieldTarget.value = ""
      
      // Submit the form after clearing coordinates
      this.submitForm()
    }
  }
  
  submitForm() {
    // Find the form and submit it
    const form = this.element.querySelector('form')
    if (form) {
      form.requestSubmit()
    }
    
    // Reset the processing flag after a short delay
    setTimeout(() => {
      this.isProcessing = false
    }, 500)
  }

  getLocation() {
    if (!navigator.geolocation) {
      this.showToast("Geolocation is not supported by your browser", "error")
      this.disableToggle(false)
      return
    }

    // Show loading indicator
    this.showToast("Getting your location...", "info")
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        // Success
        this.latitudeFieldTarget.value = position.coords.latitude.toFixed(6)
        this.longitudeFieldTarget.value = position.coords.longitude.toFixed(6)
        this.showToast("Location found!", "success")
        
        // Submit the form after successfully getting location
        this.submitForm()
      },
      (error) => {
        // Error
        console.error("Error getting location:", error)
        this.showToast(`Error getting location: ${error.message}`, "error")
        
        // Disable the toggle since we couldn't get location
        this.disableToggle(false)
        
        // Reset the processing flag
        this.isProcessing = false
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    )
  }

  disableToggle(shouldSubmit = true) {
    // Uncheck the near me checkbox
    const checkbox = document.getElementById("near_me")
    if (checkbox) {
      checkbox.checked = false
      
      // Optionally, disable the checkbox to prevent further attempts
      checkbox.disabled = true
      
      // Add a visual indication that the toggle is disabled
      const toggleElement = checkbox.nextElementSibling
      if (toggleElement) {
        toggleElement.classList.add("opacity-50", "cursor-not-allowed")
      }
      
      // Clear any existing coordinates
      this.latitudeFieldTarget.value = ""
      this.longitudeFieldTarget.value = ""
      
      // Submit the form to refresh the view without coordinates (if requested)
      if (shouldSubmit) {
        this.submitForm()
      }
    }
  }
  
  showToast(message, type = "info") {
    // Simple toast notification
    const toast = document.createElement("div")
    toast.className = `fixed bottom-4 right-4 px-4 py-2 rounded-lg shadow-lg z-50 transition-opacity duration-300 ease-in-out`
    
    // Set color based on type
    if (type === "error") {
      toast.classList.add("bg-red-500", "text-white")
    } else if (type === "success") {
      toast.classList.add("bg-green-500", "text-white")
    } else {
      toast.classList.add("bg-blue-500", "text-white")
    }
    
    toast.textContent = message
    document.body.appendChild(toast)
    
    // Fade out and remove after 3 seconds
    setTimeout(() => {
      toast.classList.add("opacity-0")
      setTimeout(() => {
        document.body.removeChild(toast)
      }, 300)
    }, 3000)
  }
}
